<template>
  <div>
    <title-edit header="Travel info" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12" style="text-align: right">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" @update="updateBranch" :model="form.branch_id" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_th" @update="updateTitleTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_en" @update="updateTitleEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Upload file :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-row>
          <v-col cols="12" md="8">
            <input-upload-file :label="form.download_url" @update="updateDownloadUrl" />
          </v-col>
          <v-col cols="12" md="4">
            <submit-button label="preview" @click.native="downloadUrl" />
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Image icon Active / InActive *:</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <input-image-upload
          id="icon1"
          height="140px"
          :model="form.icon_active_show"
          @update="updateActiveIcon"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <input-image-upload
          id="icon2"
          height="140px"
          :model="form.icon_inActive_show"
          @update="updateInActiveIcon"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Image name :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.image_name" @update="updateImageName" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Image :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-image-upload
          id="input2"
          height="200px"
          width="200px"
          :model="form.image_show"
          @update="updateImage"
          col="col-6"
        />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteTravelInfo" @save-info="saveTravelInfo" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import InputTextField from "../../../components/Input/InputTextField";
import SelectOption from "../../../components/Input/selectOption";
import InputEditor from "../../../components/Input/InputEditor";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import InputUploadFile from "../../../components/Input/InputUploadFile";
import { mapState } from "vuex";
import SubmitButton from "../../../components/Button/SubmitButton";
import {permissionTravelInfo, role} from "../../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../../components/Layout/CommandButton";

export default {
  name: "TravelInfoEdit",
  components: {
    CommandButton,
    SubmitButton,
    InputUploadFile,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputImageUpload,
    InputEditor,
    SelectOption,
    InputTextField,
    LineHr,
    TitleEdit
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  computed: {
    permissionTravelInfo,
    ...mapState({
      form: state => {
        return state.TravelInfo.form;
      }
    })
  },
  data() {
    return {
      permission : null,
      optionBranch: [],
      save_id: null
    };
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    validateSave() {
      if (!this.form.branch_id) {
        Swal('','Please select Branch !','error');
        return false;
      } else if (!this.form.title_th) {
        Swal('','Please insert Title TH !','error');
        return false;
      } else if (!this.form.title_en) {
        Swal('','Please insert Title EN !','error');
        return false;
      } else if (!this.form.description_th) {
        Swal('','Please insert Description TH !','error');
        return false;
      } else if (!this.form.description_en) {
        Swal('','Please insert Description EN !','error');
        return false;
      } else if (!this.form.icon_active_show) {
        Swal('','Please insert Active icon !','error');
        return false;
      } else if (!this.form.icon_inActive_show) {
        Swal('','Please insert Inactive icon !','error');
        return false;}
      else {
        return true;
      }
    },
    saveClose() {
      if (this.validateSave()) {
        this.$store
                .dispatch("TravelInfo/saveTravelInfo", {
                  id: this.save_id ? this.save_id : this.form.id,
                  data: this.form
                })
                .then(res => {
                  Swal(res.response_msg);
                  if (res.response_code == 200) {
                    this.goToTravelInfo();
                  }
                })
                .catch(() => {
                  Swal('','Cannot save Travel info','error');
                });
      }
    },
    saveTravelInfo() {
      if (this.validateSave()) {
        this.$store
          .dispatch("TravelInfo/saveTravelInfo", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            this.save_id = res.result.id;
            Swal(res.response_msg);
          })
          .catch(() => {
            Swal('','Cannot save Travel info','error');
          });
      }
    },
    deleteTravelInfo() {
      this.$store
        .dispatch("TravelInfo/deleteTravelInfo", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToTravelInfo();
          }
        })
        .catch(() => {
          Swal('','Cannot delete Travel info','error');
        });
    },
    goToTravelInfo() {
      this.$router.push("/services/travel-info");
    },
    downloadUrl() {
      if (this.form.download_url_show) {
        window.open(this.form.download_url_show, "_blank");
      } else {
        Swal('','File not found for download','error');
      }
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateTitleEN(val) {
      this.form.title_en = val;
    },
    updateTitleTH(val) {
      this.form.title_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateImage(val) {
      this.form.image = val.imagePath;
      this.form.image_show = val.fullImagePath;
    },
    updateImageName(val) {
      this.form.image_name = val;
    },
    updateActiveIcon(val) {
      this.form.icon_active = val.imagePath;
      this.form.icon_active_show = val.fullImagePath;
    },
    updateInActiveIcon(val) {
      this.form.icon_inActive = val.imagePath;
      this.form.icon_inActive_show = val.fullImagePath;
    },
    updateSlugUrl(val) {
      this.form.slug_url = val;
    },
    updateDownloadUrl(val) {
      this.form.download_url = val.path;
      this.form.download_url_show = val.fullPath;
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/switch.css";
</style>
